import { Flex, Input, Modal, Typography } from 'antd';

import { CANCEL, CONFIRM_TEXT, SAVE } from '@app/constants';
import { useConfirmSalaryModal } from '@app/pages/Analytics/components/ConfirmSalaryModal/hooks';
import type { ConfirmSalaryModalProps } from '@app/pages/Analytics/components/ConfirmSalaryModal/types';

const { Text } = Typography;

export const ConfirmSalaryModal: React.FC<ConfirmSalaryModalProps> = ({
  isOpen,
  selectedRowIndex,
  setSelectedRowIndex,
  setConfirmed,
  setIsOpen,
  fetchData,
  year,
  month,
  userId,
  showComment = false,
  isRevokeConfirm = false,
}) => {
  const {
    comment,
    confirmSalaryRecord,
    handleConfirmModalClose,
    handleCommentChange,
    handleRevokeConfirm,
  } = useConfirmSalaryModal({
    selectedRowIndex,
    setConfirmed,
    setSelectedRowIndex,
    setIsOpen,
    fetchData,
    year,
    month,
    userId,
  });

  return (
    <Modal
      open={isOpen}
      onCancel={handleConfirmModalClose}
      onOk={isRevokeConfirm ? handleRevokeConfirm : confirmSalaryRecord}
      title={
        isRevokeConfirm
          ? 'Отмена подтверждения заработной платы'
          : 'Подтверждение поступления зарплаты'
      }
      okText={isRevokeConfirm ? CONFIRM_TEXT : SAVE}
      cancelText={CANCEL}
    >
      <Flex vertical gap={16}>
        <Text>
          {isRevokeConfirm
            ? 'Вы уверены, что хотите отменить подтверждение получения заработной платы?'
            : 'Вы уверены, что хотите подтвердить поступление заработной платы?'}
        </Text>
        {showComment && !isRevokeConfirm && (
          <>
            <Text strong>Дополнительно можете указать комментарий</Text>
            <Input
              size="large"
              maxLength={4000}
              value={comment}
              onChange={handleCommentChange}
            />
          </>
        )}
      </Flex>
    </Modal>
  );
};
